export default __webpack_public_path__ + "assets/proof-of-value-agreement.272de365a2d748bc47b4b97eb917542e.pdf";